import React from "react"

import { withAuthenticationRequired } from "@auth0/auth0-react"
import { useIntl } from "react-intl"

import Layout from "../components/layout"
import SEO from "../components/seo"
import WalletNavigation from "../components/wallet_navigation"
import WalletBalances from "../components/wallet_balances"

const WalletBalancesPage = ({ location }) => {
  const intl = useIntl()
  const pageTitle = intl.formatMessage({ id: "Balances" })
  return (
    <Layout pageTitle={pageTitle} location={location}>
      <SEO title={pageTitle} />
      <WalletNavigation location={location} />
      <WalletBalances />
    </Layout>
  )
}

export default withAuthenticationRequired(WalletBalancesPage)
